export type Language = 'cs' | 'en';

export const translations = {
  cs: {
    nav: {
      social: 'Sociální sítě',
      home: 'Domů',
      gallery: 'Galerie',
      about: 'O mně',
      process: 'Realizace masky',
      faq: 'FAQ',
      contact: 'Kontakt',
    },
    hero: {
      banners: [
        'Vtiskni svůj příběh do masky',
        'Každý detail je důležitý!',
        'Navrhnu a vytvořím Vám unikátní design',
      ],
      subtitle: 'Netvořím jen masky, tvořím vaše příběhy',
      cta: 'OBJEDNAT',
    },
    gallery: {
      title: 'Moje práce',
      subtitle: 'Každá maska je unikátní umělecké dílo',
      viewAll: 'Zobrazit celou galerii',
      showAll: 'Zobrazit vše',
      showLess: 'Skrýt',
    },
    whyUs: {
      title: 'Proč Tom Art Mask',
      items: [
        { title: 'Originalita a kreativita', desc: 'Každý design je unikátní originál vytvořený na míru' },
        { title: '19+ let zkušeností', desc: 'Dlouholeté zkušenosti s airbrush malbou a designem' },
        { title: 'Individuální přístup', desc: 'Osobní konzultace a návrh přesně podle vašich představ' },
        { title: 'Ruční práce', desc: 'Každý detail malován ručně s maximální precizností' },
        { title: 'Kvalitní materiály', desc: 'Profesionální airbrush barvy a laky nejvyšší kvality' },
        { title: 'Profesionální lak', desc: 'Odolný lak chránící design při hře' },
      ],
    },
    about: {
      title: 'Airbrush hokejových masek',
      name: 'Tradice a umění z hokejového srdce Třebíče',
      bio: 'Jsem rodák z Třebíče a hokej mám v krvi. Naše město pro mě není jen adresou, je to hokejová bašta s neuvěřitelnou historií. Vyrostl jsem na tribunách našeho zimáku a dnes tam sám vyjíždím na led. Právě tady, v Třebíči, propojuji svou celoživotní vášeň pro hokej s precizním uměním airbrushe.',
      bio2: 'Už jako malého kluka mě fascinovali brankáři. Nebyli to pro mě jen hráči, byli to hrdinové v maskách. Vždycky mě přitahovala ta kombinace strachu a odvahy, ale hlavně – design jejich masek. Maska je pro gólmana víc než jen ochrana; je to jeho tvář, jeho identita a jeho příběh. Moje cesta k airbrushi hokejových masek byla přirozená. Odjakživa mě bavila grafika a jako amatérský hráč hokeje vím o tomhle sportu úplně všechno. Znám tu atmosféru v šatně, zvuk puku o beton i to, jak dostává výstroj zabrat. Díky tomu k maskám přistupuji jinak – s respektem hráče a precizností grafika.',
      bio3: 'Jako třebíčský rodák jsem nesmírně hrdý na to, že moje práce zdobí masky brankářů v našem domácím klubu SK Horácká Slavia Třebíč. Spolupráce s profesionály z "Horácké" je pro mě potvrzením, že poctivé řemeslo z Třebíče patří na tu nejvyšší úroveň.',
      bio4: 'Chcete masku, která budí respekt? Ať už chytáte profi ligu, nebo hrajete s kamarády pro radost, vaše maska je vaše vizitka. Airbrush masek v Třebíči dělám srdcem, protože hokej je můj život a Třebíč můj domov.',
    },
    process: {
      title: 'Realizace masky',
      steps: [
        { title: 'Design', desc: 'Konzultace a příprava unikátního digitálního návrhu podle vašich představ' },
        { title: 'Airbrush', desc: 'Ruční airbrush malba s precizním důrazem na každý detail' },
        { title: 'Clear Coat', desc: 'Profesionální lak chránící design při hře na nejvyšší úrovni' },
      ],
    },
    wallOfFame: {
      title: 'Wall of Fame',
      subtitle: 'Hráči a týmy, pro které tvoříme',
      viewGallery: 'Prohlédnout galerii',
    },
    voucher: {
      title: 'Dárkový Voucher',
      text1: 'Být brankářem znamená být pilířem týmu. Tvůj postoj, tvé zákroky a tvá hokejová maska nebo florbalová maska definují, kdo jsi. Tento voucher ti otevírá dveře do Tom Art Mask, kde tvé sny o profesionálním designu proměním v realitu.',
      text2: 'Specializuji se na zakázkový airbrush masek s důrazem na detaily ostré jako nůž a styl, který tě odliší od všech ostatních v lize. Ať už potřebuješ originální nástřik helmy v klubových barvách nebo kompletní grafický návrh masky na míru, Tom Art Mask ti dá brankářské výstroji tvář.',
      download: 'Stáhnout dárkový Voucher',
    },
    contact: {
      title: 'Custom Objednávka',
      subtitle: 'Připravíme vám elitní masku na míru. Napište nám!',
      name: 'Jméno',
      email: 'Email',
      phone: 'Telefon',
      message: 'Popište vaše přání',
      send: 'Odeslat zprávu',
      whatsapp: 'Napsat na WhatsApp',
      uploadLabel: 'Přetáhněte sem referenční obrázek',
      uploadHint: 'nebo klikněte pro výběr souboru',
      fileSelected: 'Soubor vybrán',
    },
    footer: {
      rights: 'Všechna práva vyhrazena.',
    },
    masks: [
      { name: 'Slavia Praha – Florbal', desc: 'Florbalová maska v barvách Slavie Praha' },
      { name: 'Český lev', desc: 'Hokejová maska s motivem českého lva' },
      { name: 'Kladno Retro', desc: 'Retro design hokejové masky pro Kladno' },
      { name: 'Dánsko', desc: 'Hokejová maska pro dánského brankáře' },
      { name: 'HC Česká Lípa', desc: 'Hokejová maska pro HC Česká Lípa' },
      { name: 'HC Slavoj Zbraslav', desc: 'Hokejová maska pro HC Slavoj Zbraslav' },
      { name: 'HC VERVA Litvínov', desc: 'Hokejová maska v barvách Litvínova' },
      { name: 'HC Vimperk', desc: 'Hokejová maska pro HC Vimperk' },
      { name: 'HST – A-Tým', desc: 'Maska pro A-Tým Horácké Slavie Třebíč' },
      { name: 'Horácká Slavia Třebíč', desc: 'Klubová maska Horácké Slavie Třebíč' },
      { name: 'Sharks Brno', desc: 'Maska pro HC Sharks Brno' },
      { name: 'TTC', desc: 'Hokejová maska pro TTC' },
      { name: 'Uherské Hradiště', desc: 'Hokejová maska pro Uherské Hradiště' },
      { name: 'Slovensko II', desc: 'Hokejová maska se slovenským motivem' },
      { name: 'Slovensko', desc: 'Hokejová maska na slovenský led' },
      { name: 'HST – od Třebíče', desc: 'Maska od Horácké Slavie Třebíč' },
      { name: 'Medvěd', desc: 'Hokejová maska s motivem medvěda' },
      { name: 'Patrik Eliáš', desc: 'Hokejová maska s poctou Patriku Eliášovi' },
      { name: 'Predátor', desc: 'Hokejová maska s motivem predátora' },
      { name: 'Sparťan', desc: 'Hokejová maska s motivem sparťana' },
      { name: 'Thor', desc: 'Hokejová maska s motivem Thora' },
      { name: 'Třinec', desc: 'Hokejová maska v barvách Třince' },
      { name: 'Vetřelec', desc: 'Hokejová maska s motivem vetřelce' },
      { name: 'Panter', desc: 'Hokejová maska s motivem pantera' },
      { name: 'Štír', desc: 'Hokejová maska s motivem štíra' },
    ],
    stats: {
      items: [
        { value: 200, suffix: '+', label: 'Hotových masek' },
        { value: 19, suffix: '+', label: 'Let zkušeností' },
        { value: 100, suffix: '%', label: 'Spokojených zákazníků' },
      ],
    },
    beforeAfter: {
      title: 'Před & Po',
      subtitle: 'Podívejte se na proměnu čisté masky v unikátní umělecké dílo',
      before: 'Před',
      after: 'Po',
    },
    social: {
      title: 'Sledujte nás',
      subtitle: 'Sledujte mě na sociálních sítích, ať vám neuniknou žádné novinky!',
      instagramDesc: 'Sledujte proces tvorby, hotové masky a zákulisí na Instagramu',
      followInstagram: 'Sledovat na Instagramu',
      followFacebook: 'Sledovat na Facebooku',
      tiktokDesc: 'Krátká videa z procesu tvorby a hotových masek na TikToku',
      followTiktok: 'Sledovat na TikToku',
    },
    testimonials: {
      title: 'Co říkají zákazníci',
      videoTitle: 'Video reference',
      items: [
        { name: 'Richard Nesiba', quote: 'Pecka' },
        { name: 'Tomáš Horák', quote: 'Tome maska od Tebe je nádherná, ale jako mega. Díky moc, skvělá práce. Jsi Mistr Tome' },
        { name: 'Peter Babkovič', quote: 'Krásna a nádherná. Ďakujem moc za ukážkovú spoluprácu. Chcel by som sa ešte raz poďakovať Tom Art Mask za precíznu, výbornú a profesionálnu prácu na dizajne mojej novej masky. Spolupráca bola bezchybná a vrele odporúčam každému, kto chce mať masku ako umelecké dielo. Prajem veľa zdaru a zákazníkov' },
        { name: 'Dominik Bartko', quote: 'Ďakujem ti krásne kamarát za takúto nádheru. Si fakt človek na správnom mieste ktorý má cit pre detail a k tomu ešte neskutočné šikovný. Ja tebe sa chcem poďakovať za super spoluprácu, komunikáciu a najmä za tvoj ľudský prístup k zákazníkovi... to sa v dnešnej dobe len tak nevidí. Ďakujem' },
        { name: 'Sára Pánovová', quote: 'BOMBA' },
        { name: 'Martin Urban', quote: 'Chtěli jsme tímto způsobem moc poděkovat Tom Art Mask za báječnou spolupráci, to, jak pochopil a uchopil celý design masky pro „čapátora" je naprosto dokonalý, je to mistr svého řemesla! Naprostý profesionál každým coulem! Masku odvedl k naprosté dokonalosti a nebude to jen součást výstroje, ale umělecké dílo, které bude dělat každý trénink a zápas radost našemu synovi. Patří Vám naše obrovské DÍKY!' },
        { name: 'Petra Cahová', quote: 'Jony sklízí s maskou obdiv na turnajích po celé republice, děkujeme ještě jednou.' },
        { name: 'Alda Pomajbík', quote: 'Fantazie' },
        { name: 'Honza Smetana', quote: 'Dost dobrý, nejsou slova která by to vyjádřila, děkuju je neskutečné co dokážete' },
        { name: 'Michal Woldřich', quote: 'Tak to je neskutečná práce. Návrh je sice hezký, ale v reálu na masce je to teprve ono. Super práce Tome.' },
      ],
    },
    map: {
      title: 'Dodáváme po celé Evropě',
      subtitle: 'Ruční airbrush práce z České republiky pro brankáře po celé Evropě',
      madeIn: '✦ Handmade in Czech Republic',
      description: 'Ruční airbrush práce z České republiky. Každá maska je originál vytvořený s maximální péčí a dodaný kamkoli v Evropě.',
      world: 'Evropa',
      czechRepublic: 'Česká republika',
      homeBase: 'Domovské město',
    },
    faq: {
      title: 'Nejčastější otázky',
      subtitle: 'Odpovědi na nejčastější dotazy ohledně custom airbrush masek',
      items: [
        { q: 'Kolik stojí airbrush hokejové masky?', a: 'Cena se odvíjí od složitosti designu a typu masky. Kontaktujte mě pro individuální cenovou nabídku.' },
        { q: 'Jak dlouho trvá výroba designu?', a: 'Standardní doba je 2–4 týdny. Zahrnuje to návrh, přípravu povrchu, samotnou malbu a několik vrstev laku s procesem vytvrzování a finálové leštění laku.' },
        { q: 'Děláte i grafický návrh, nebo musím mít svůj?', a: 'Nabízím konzultaci a tvorbu digitálního náhledu před samotným stříkáním.' },
        { q: 'Jak probíhá objednávka?', a: 'Nejprve spolu probereme váš nápad, připravím digitální návrh ke schválení a poté začnu s realizací.' },
        { q: 'Je lak odolný vůči pukům?', a: 'Ano, používám profesionální vícevrstvý lak, který chrání design během hry.' },
        { q: 'Můžu si nechat přestříkat i starší, použitou masku?', a: 'Ano, ale vyžaduje to náročnější přípravu (odstranění starého laku a opravu škrábanců).' },
        { q: 'Posíláte masky i do zahraničí?', a: 'Ano, masky zasílám po celé Evropě. Kontaktujte mě pro detaily o doručení.' },
      ],
    },
    spray: {
      title: 'Vysprejuj si svou masku',
      subtitle: 'Vyzkoušej si, jaké to je být airbrush umělcem!',
      spray: 'Sprej',
      brush: 'Štětec',
      eraser: 'Guma',
      reset: 'Reset',
      download: 'Stáhnout',
      cta: 'Chceš takovou masku doopravdy?',
      ctaBtn: 'Kontaktuj Toma!',
      size: 'Velikost',
      upload: 'Přidat obrázek',
      defaultMask: 'Výchozí maska',
      undo: 'Zpět',
      redo: 'Vpřed',
      opacity: 'Průhlednost',
      confirmStamp: 'Potvrdit',
      cancelStamp: 'Zrušit',
      stampSize: 'Velikost obrázku',
    },
    configurator: {
      title: 'Konfigurátor masky',
      subtitle: 'Navrhněte si svou vysněnou masku v pár krocích',
      step1: 'Typ masky',
      hockey: 'Hokejová',
      floorball: 'Florbalová',
      step2: 'Barevné schéma',
      dark: 'Temná',
      fire: 'Oheň',
      ice: 'Led',
      forest: 'Les',
      royal: 'Královská',
      custom: 'Vlastní',
      step3: 'Styl motivu',
      animal: 'Zvíře',
      character: 'Postava',
      'team-logo': 'Týmové logo',
      step4: 'Popište svou vizi',
      descPlaceholder: 'Popište, co byste si představovali na masce...',
      step5: 'Kontakt',
      name: 'Jméno',
      email: 'Email',
      send: 'Odeslat poptávku',
      next: 'Další',
      prev: 'Zpět',
      success: 'Poptávka odeslána! Ozvu se vám co nejdříve.',
      successTitle: 'Děkujeme!',
    },
  },
  en: {
    nav: {
      social: 'Social Media',
      home: 'Home',
      gallery: 'Gallery',
      about: 'About',
      process: 'Mask Creation',
      faq: 'FAQ',
      contact: 'Contact',
    },
    hero: {
      banners: [
        'Imprint your story into the mask',
        'Every detail matters!',
        'I design and create unique artwork for you',
      ],
      subtitle: "I don't just create masks, I create your stories",
      cta: 'ORDER',
    },
    gallery: {
      title: 'My Work',
      subtitle: 'Each mask is a unique piece of art',
      viewAll: 'View full gallery',
      showAll: 'Show all',
      showLess: 'Show less',
    },
    whyUs: {
      title: 'Why Tom Art Mask',
      items: [
        { title: 'Originality & Creativity', desc: 'Every design is a unique original tailored to you' },
        { title: '19+ Years of Experience', desc: 'Decades of experience in airbrush painting and design' },
        { title: 'Individual Approach', desc: 'Personal consultation and design exactly to your vision' },
        { title: 'Handcrafted', desc: 'Every detail painted by hand with maximum precision' },
        { title: 'Quality Materials', desc: 'Professional airbrush paints and top-quality lacquers' },
        { title: 'Professional Finish', desc: 'Durable lacquer protecting the design during play' },
      ],
    },
    about: {
      title: 'Airbrush Hockey Masks',
      name: 'Tradition and Art from the Hockey Heart of Třebíč',
      bio: "I'm a native of Třebíč and hockey runs in my blood. Our city isn't just an address for me – it's a hockey stronghold with an incredible history. I grew up in the stands of our ice rink and today I skate there myself. Right here, in Třebíč, I combine my lifelong passion for hockey with the precise art of airbrush.",
      bio2: "As a kid, I was fascinated by goalies. They weren't just players to me – they were heroes in masks. I was always drawn to that combination of fear and courage, but most of all – the design of their masks. A mask is more than just protection for a goalie; it's his face, his identity, and his story. My path to airbrushing hockey masks was natural. I've always loved graphic design, and as an amateur hockey player, I know everything about this sport. I know the atmosphere in the locker room, the sound of a puck hitting concrete, and how gear takes a beating. That's why I approach masks differently – with a player's respect and a designer's precision.",
      bio3: "As a Třebíč native, I'm immensely proud that my work decorates the masks of goalies at our home club SK Horácká Slavia Třebíč. Collaborating with professionals from 'Horácká' confirms that honest craftsmanship from Třebíč belongs at the highest level.",
      bio4: "Want a mask that commands respect? Whether you play in a pro league or just for fun with friends, your mask is your calling card. I airbrush masks in Třebíč with heart, because hockey is my life and Třebíč is my home.",
    },
    process: {
      title: 'Mask Creation',
      steps: [
        { title: 'Design', desc: 'Consultation and creation of a unique digital design tailored to your vision' },
        { title: 'Airbrush', desc: 'Hand-painted airbrush art with precision attention to every detail' },
        { title: 'Clear Coat', desc: 'Professional lacquer finish protecting the design at the highest level' },
      ],
    },
    wallOfFame: {
      title: 'Wall of Fame',
      subtitle: 'Players and teams we create for',
      viewGallery: 'View gallery',
    },
    voucher: {
      title: 'Gift Voucher',
      text1: 'Being a goalie means being the pillar of the team. Your stance, your saves and your hockey or floorball mask define who you are. This voucher opens the door to Tom Art Mask, where I turn your dreams of professional design into reality.',
      text2: 'I specialize in custom airbrush masks with razor-sharp attention to detail and a style that sets you apart from everyone else in the league. Whether you need an original helmet paint job in club colors or a complete custom mask design, Tom Art Mask gives your goalie gear a face.',
      download: 'Download Gift Voucher',
    },
    contact: {
      title: 'Custom Order',
      subtitle: 'We\'ll craft an elite mask tailored just for you. Get in touch!',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Describe your vision',
      send: 'Send message',
      whatsapp: 'Message on WhatsApp',
      uploadLabel: 'Drag & drop a reference image here',
      uploadHint: 'or click to select a file',
      fileSelected: 'File selected',
    },
    footer: {
      rights: 'All rights reserved.',
    },
    masks: [
      { name: 'Slavia Praha – Floorball', desc: 'Floorball mask in Slavia Praha colors' },
      { name: 'Czech Lion', desc: 'Hockey mask with Czech lion motif' },
      { name: 'Kladno Retro', desc: 'Retro hockey mask design for Kladno' },
      { name: 'Denmark', desc: 'Hockey mask for a Danish goalie' },
      { name: 'HC Česká Lípa', desc: 'Hockey mask for HC Česká Lípa' },
      { name: 'HC Slavoj Zbraslav', desc: 'Hockey mask for HC Slavoj Zbraslav' },
      { name: 'HC VERVA Litvínov', desc: 'Hockey mask in Litvínov colors' },
      { name: 'HC Vimperk', desc: 'Hockey mask for HC Vimperk' },
      { name: 'HST – A-Team', desc: 'Mask for A-Team of Horácká Slavia Třebíč' },
      { name: 'Horácká Slavia Třebíč', desc: 'Club mask of Horácká Slavia Třebíč' },
      { name: 'Sharks Brno', desc: 'Mask for HC Sharks Brno' },
      { name: 'TTC', desc: 'Hockey mask for TTC' },
      { name: 'Uherské Hradiště', desc: 'Hockey mask for Uherské Hradiště' },
      { name: 'Slovakia II', desc: 'Hockey mask with Slovak motif' },
      { name: 'Slovakia', desc: 'Hockey mask for Slovak ice' },
      { name: 'HST – from Třebíč', desc: 'Mask from Horácká Slavia Třebíč' },
      { name: 'Bear', desc: 'Hockey mask with bear motif' },
      { name: 'Patrik Eliáš', desc: 'Hockey mask tribute to Patrik Eliáš' },
      { name: 'Predator', desc: 'Hockey mask with predator motif' },
      { name: 'Spartan', desc: 'Hockey mask with Spartan motif' },
      { name: 'Thor', desc: 'Hockey mask with Thor motif' },
      { name: 'Třinec', desc: 'Hockey mask in Třinec colors' },
      { name: 'Alien', desc: 'Hockey mask with alien motif' },
      { name: 'Panther', desc: 'Hockey mask with panther motif' },
      { name: 'Scorpion', desc: 'Hockey mask with scorpion motif' },
    ],
    stats: {
      items: [
        { value: 200, suffix: '+', label: 'Masks completed' },
        { value: 19, suffix: '+', label: 'Years of experience' },
        { value: 100, suffix: '%', label: 'Satisfied customers' },
      ],
    },
    beforeAfter: {
      title: 'Before & After',
      subtitle: 'See the transformation from a clean mask to a unique work of art',
      before: 'Before',
      after: 'After',
    },
    social: {
      title: 'Follow Us',
      subtitle: "Follow me on social media so you don't miss any news!",
      instagramDesc: 'Follow the creative process, finished masks and behind the scenes on Instagram',
      followInstagram: 'Follow on Instagram',
      followFacebook: 'Follow on Facebook',
      tiktokDesc: 'Short videos of the creative process and finished masks on TikTok',
      followTiktok: 'Follow on TikTok',
    },
    testimonials: {
      title: 'What Customers Say',
      videoTitle: 'Video References',
      items: [
        { name: 'Richard Nesiba', quote: 'Amazing' },
        { name: 'Tomáš Horák', quote: 'Tome, the mask from you is gorgeous, absolutely mega. Thanks a lot, great work. You are a Master, Tome' },
        { name: 'Peter Babkovič', quote: 'Beautiful and stunning. Thank you so much for the exemplary collaboration. I would like to thank Tom Art Mask once again for the precise, excellent and professional work on my new mask design. The collaboration was flawless and I warmly recommend it to anyone who wants a mask as a work of art.' },
        { name: 'Dominik Bartko', quote: 'Thank you so much buddy for such beauty. You are truly a person in the right place who has a sense for detail and on top of that incredibly skilled. I want to thank you for the great collaboration, communication and especially your human approach to the customer... that is rarely seen these days. Thank you' },
        { name: 'Sára Pánovová', quote: 'BOMB' },
        { name: 'Martin Urban', quote: 'We wanted to thank Tom Art Mask for the wonderful collaboration. The way he understood and executed the entire mask design is absolutely perfect — he is a master of his craft! A complete professional in every way! The mask is not just part of the gear but a work of art that brings joy to our son every practice and game. You have our enormous THANKS!' },
        { name: 'Petra Cahová', quote: 'Jony gets admiration for the mask at tournaments all over the country, thank you once again.' },
        { name: 'Alda Pomajbík', quote: 'Fantasy' },
        { name: 'Honza Smetana', quote: 'Really good, there are no words to express it, thank you — what you can do is incredible' },
        { name: 'Michal Woldřich', quote: 'That is incredible work. The design is nice, but in reality on the mask it\'s truly something. Super work, Tome.' },
      ],
    },
    map: {
      title: 'Delivery Across Europe',
      subtitle: 'Handcrafted airbrush art from the Czech Republic for goalies across Europe',
      madeIn: '✦ Handmade in Czech Republic',
      description: 'Handcrafted airbrush art from the Czech Republic. Every mask is an original created with utmost care and delivered anywhere in Europe.',
      world: 'Europe',
      czechRepublic: 'Czech Republic',
      homeBase: 'Home base',
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Answers to the most common questions about custom airbrush masks',
      items: [
        { q: 'How much does an airbrush hockey mask cost?', a: 'The price depends on the complexity of the design and type of mask. Contact me for an individual quote.' },
        { q: 'How long does the design take?', a: 'The standard time is 2–4 weeks. This includes the design, surface preparation, painting itself and multiple layers of lacquer with curing process and final polishing.' },
        { q: 'Do you create graphic designs, or do I need my own?', a: 'I offer consultation and creation of a digital preview before the actual airbrushing.' },
        { q: 'How does the ordering process work?', a: 'First, we discuss your idea, I prepare a digital design for approval, and then I start the creation process.' },
        { q: 'Is the lacquer resistant to pucks?', a: 'Yes, I use professional multi-layer lacquer that protects the design during play.' },
        { q: 'Can I have an older, used mask repainted?', a: 'Yes, but it requires more intensive preparation (removing old lacquer and repairing scratches).' },
        { q: 'Do you ship masks abroad?', a: 'Yes, I ship masks across Europe. Contact me for delivery details.' },
      ],
    },
    spray: {
      title: 'Spray Your Own Mask',
      subtitle: 'Try what it feels like to be an airbrush artist!',
      spray: 'Spray',
      brush: 'Brush',
      eraser: 'Eraser',
      reset: 'Reset',
      download: 'Download',
      cta: 'Want a real mask like this?',
      ctaBtn: 'Contact Tom!',
      size: 'Size',
      upload: 'Add Image',
      defaultMask: 'Default Mask',
      undo: 'Undo',
      redo: 'Redo',
      opacity: 'Opacity',
      confirmStamp: 'Confirm',
      cancelStamp: 'Cancel',
      stampSize: 'Image Size',
    },
    configurator: {
      title: 'Mask Configurator',
      subtitle: 'Design your dream mask in a few steps',
      step1: 'Mask Type',
      hockey: 'Hockey',
      floorball: 'Floorball',
      step2: 'Color Scheme',
      dark: 'Dark',
      fire: 'Fire',
      ice: 'Ice',
      forest: 'Forest',
      royal: 'Royal',
      custom: 'Custom',
      step3: 'Motif Style',
      animal: 'Animal',
      character: 'Character',
      'team-logo': 'Team Logo',
      step4: 'Describe Your Vision',
      descPlaceholder: 'Describe what you envision on the mask...',
      step5: 'Contact',
      name: 'Name',
      email: 'Email',
      send: 'Send Inquiry',
      next: 'Next',
      prev: 'Back',
      success: 'Inquiry sent! I will get back to you as soon as possible.',
      successTitle: 'Thank You!',
    },
  },
} as const;
